import { FC } from "react";

import Modal from "../../../../components/Modal/Modal";
import Button from "../../../../components/Button/Button";
import { ManagedAccount } from "../../../../store/agency/types";
import { getDisplayName } from "../../utils";

import styles from "./DetachConfirmModal.module.css";

interface DetachConfirmModalProps {
  client: ManagedAccount | null;
  onConfirm: () => void;
  onClose: () => void;
}

const cls = (el?: string) => styles[el ? `detach-modal__${el}` : "detach-modal"];

const DetachConfirmModal: FC<DetachConfirmModalProps> = ({ client, onConfirm, onClose }) => {
  if (!client) return null;

  return (
    <Modal isOpen={!!client} onClose={onClose}>
      <div className={cls()}>
        <h3 className={cls("title")}>Detach Client</h3>
        <p className={cls("text")}>
          Are you sure you want to detach <strong>{getDisplayName(client)}</strong>?
          You will lose access to manage this client&apos;s account.
        </p>
        <div className={cls("actions")}>
          <Button
            label="Cancel"
            typeStyle="outline"
            size="md"
            onClick={onClose}
            type="button"
          />
          <Button
            label="Detach"
            typeStyle="fill-dark"
            size="md"
            onClick={onConfirm}
            type="button"
            className={cls("confirm")}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DetachConfirmModal;
